import "./index.scss";

import { Box } from "@mui/material";
import { TPGPLongTermGoal } from "models/tca";
import { useEffect, useState } from "react";

import Certification from "./Certification";
import ContractPreparation from "./ContractPreparation";
import ContractPreview from "./ContractPreview";

const TCAContract = (props: {
  goals: TPGPLongTermGoal[];
  currentTab: string;
  member: any;
  view: "preparation" | "preview" | "certificate";
  contractWorkoutSessions: number;
  contractNumberOfWeeks: number;
  appointmentNumber?: number;
  sendContractToBackend?: () => {};
}) => {
  const {
    goals,
    currentTab,
    member,
    view,
    contractWorkoutSessions,
    contractNumberOfWeeks,
    appointmentNumber,
    sendContractToBackend,
  } = props;
  const [currentView, setCurrentView] = useState<string>();

  useEffect(() => {
    setCurrentView(view);
  }, [view]);

  if (currentTab !== "contract") return null;
  return (
    <Box className="tcaContract">
      {currentView === "preparation" && (
        <ContractPreparation goals={goals} appointmentNumber={appointmentNumber} />
      )}
      {currentView === "preview" && (
        <ContractPreview
          goals={goals}
          contractWorkoutSessions={contractWorkoutSessions}
          contractNumberOfWeeks={contractNumberOfWeeks}
          sendContractToBackend={sendContractToBackend}
        />
      )}
      {currentView === "certificate" && (
        <Certification member={member} sendContractToBackend={sendContractToBackend} />
      )}
    </Box>
  );
};

export default TCAContract;
